import { render, staticRenderFns } from "./CardBrand.vue?vue&type=template&id=15ed1b60&scoped=true"
import script from "./CardBrand.vue?vue&type=script&lang=js"
export * from "./CardBrand.vue?vue&type=script&lang=js"
import style0 from "./CardBrand.vue?vue&type=style&index=0&id=15ed1b60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ed1b60",
  null
  
)

export default component.exports